import { useLayoutEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// components
import Header2 from "../common/header";
import Footer from "../common/footer";
import Modal from "../login-register/modal";
import CartModal from "./../cartModal/cartModal";
import { showCartModal } from "../../store/slices/cartModalSlice";
import ScrollToTopBtn from "../common/scrollToTopBtn";

const LayoutWithNav = () => {
  const [isMediumScreen, setIsMediumScreen] = useState(false);
  const showLoginModal = useSelector((state) => state.loginModal.show);
  const showCart = useSelector((state) => state.cartModal.show);
  const cart = useSelector((state) => state.cart.cart);
  const dispatch = useDispatch();

  const handleCloseCart = () => {
    dispatch(showCartModal(false));
  };

  useLayoutEffect(() => {
    function updateSize() {
      setIsMediumScreen(window.innerWidth <= 991 ? true : false);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  // SEO Structured Data for Security Business
  const businessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Nakuru Security Solutions",
    description:
      "Professional CCTV installation, biometric systems, intruder alarms, electric fencing, and security solutions in Nakuru, Kenya",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Nakuru Wilmur house room 11, Kenyatta avenue,Next To Family Bank",
      addressLocality: "Nakuru",
      addressRegion: "Rift Valley",
      addressCountry: "KE",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: -0.303099,
      longitude: 36.080026,
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "17:00",
      },
    ],
    telephone: "+254XXXXXXXXX",
    image: "/logo.png",
    priceRange: "$$",
    service: [
      "CCTV Solutions",
      "Biometric Attendance Systems",
      "Intruder Alarm Systems",
      "Electric Fencing",
      "Networking Solutions",
    ],
    areaServed: ["Nakuru", "Rift Valley", "Kenya"],
  };

  return (
    <>
      {/* Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify(businessSchema)}
      </script>

      <Header2 cart={cart} isMediumScreen={isMediumScreen} />

      {showLoginModal && <Modal />}

      <div className="shopping-cart-container">
        {showCart && (
          <>
            <div
              className="modal-backdrop cartmodal-backdrop"
              onClick={handleCloseCart}
              role="presentation"
              aria-hidden={!showCart}
            ></div>
            <CartModal
              showModal={showCart}
              hideModal={handleCloseCart}
              aria-modal="true"
              role="dialog"
            />
          </>
        )}
      </div>

      {/* Main Content Area - SEO Critical */}
      <main
        id="main-content"
        className="content-wrapper"
        itemScope
        itemType="https://schema.org/Service"
      >
        <Outlet />
      </main>

      <Footer />
      <ScrollToTopBtn />
    </>
  );
};

export default LayoutWithNav;
